<template>
    <div :style="showTab ? 'position: relative; z-index: 99; top: -100px;' : ''" class="animal">
        <template v-if="showTab">
            <div class="tabBox">
                <div @click="tabBarChange1(index)" :class="index == tabValueIndex1 ? 'active' : ''"
                    v-for="(item, index) in content" :key="item.value" class="tabItem">{{ item.label }}</div>
            </div>
            <div class="tabBox2">
                <div @click="tabBarChange2(index)" :class="index == tabValueIndex2 ? 'activeItem2' : ''"
                    :style="{ backgroundImage: `url('${item.cover}')`, }"
                    v-for="(item, index) in content[tabValueIndex1].children" :key="item.id" class="tabItem2">
                    <span class="textCenter"> {{ item.title }}</span>
                </div>
            </div>
        </template>
        <div :style="showTab ? 'padding-bottom: 0px;' : ''" class="content">
            <div class="title">{{ showTitle }}</div>
            <div class="listBox">
                <div @click="itemClick(item)" v-for="item in showList" :key="item.id" class="listItem">
                    <img :src="item.cover" alt="" />
                    <img v-if="item.new == 1" class="newTag" src="@/assets/index/NewIcon.png" alt="" />
                    <div class="name">{{ item.title }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        titleText: {
            type: String,
            default: '',
        },
        content: {
            type: Array,
            default: (() => [])
        },
    },
    computed: {
        showTab() {
            return this.content.length ? this.content[0].children ? true : false : false
        },
        showList() {
            if (!this.content.length) return []
            if (!this.content[0].children) return this.content
            return this.content[this.tabValueIndex1].children[this.tabValueIndex2].children
        },
        showTitle() {
            if (!this.content.length) return this.titleText
            if (!this.content[0].children) return this.titleText
            return this.content[this.tabValueIndex1].children[this.tabValueIndex2].title
        }
    },
    data() {
        return {
            tabValueIndex1: 0,
            tabValueIndex2: 0,
        }
    },
    created() {

    },
    mounted() {
        let { index } = this.$route.query
        if (index) {
            this.tabBarChange1(index)
        }
    },
    methods: {
        tabBarChange1(index) {
            this.tabValueIndex1 = index
            this.tabValueIndex2 = 0
            this.$emit('tabChange', index)
        },
        tabBarChange2(index) {
            this.tabValueIndex2 = index
        },
        itemClick(data) {
            this.$emit('itemClick', { data, showTab: this.showTab })
        },
    }
}
</script>

<style scoped lang="scss">
.animal {
    width: 1200px;
    margin: auto;
    background-color: #fff;

    .tabBox {
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #888888;
        height: 100px;
        box-sizing: border-box;


        .tabItem {
            height: 100px;
            line-height: 100px;
            font-size: 24px;
            color: #000000;
            width: 450px;
            text-align: center;
            cursor: pointer;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                left: 50%;
                bottom: 0;
                width: 0%;
                height: 2px;
                background: #4B4B4B;
                transition: all 0.3s;
            }
        }

        .active {
            &::after {
                content: '';
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 2px;
                background: #4B4B4B;
            }
        }
    }

    .tabBox2 {
        margin-top: 30px;
        display: flex;
        align-items: center;
        gap: 30px;

        .tabItem2 {
            width: 277px;
            height: 155px;
            cursor: pointer;

            .textCenter {
                display: block;
                width: 277px;
                height: 155px;
                line-height: 155px;
                text-align: center;
                color: #fff;
                font-size: 22px;
                font-weight: 300;
                background: linear - gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.8));
            }

        }

        .activeItem2 {
            .textCenter {
                font-weight: bold;
                background: transparent;
            }
        }
    }

    .content {
        margin-top: 116px;
        padding-bottom: 90px;

        .title {
            font-size: 30px;
            color: #000000;
            line-height: 30px;
            padding-bottom: 22px;
            // border-bottom: 1px solid #888888;
        }

        .listBox {
            margin-top: 30px;
            display: flex;
            flex-wrap: wrap;
            gap: 30px;

            .listItem {
                width: 380px;
                margin-bottom: 30px;
                cursor: pointer;
                position: relative;

                .newTag {
                    width: 40px;
                    height: 20px;
                    position: absolute;
                    right: 30px;
                    top: 20px;
                }

                img {
                    width: 100%;
                    height: 300px;
                    display: block;
                    object-fit: contain;
                    background-color: #F8F7F7;
                }

                .name {
                    text-align: center;
                    margin-top: 28px;
                    text-align: center;
                    font-size: 20px;
                    color: #000000;
                    line-height: 24px;
                }
            }
        }
    }
}

@media screen and (max-width:1200px) {

    .animal {
        width: 100%;
        margin: auto;

        .tabBox {
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom: 1px solid #888888;

            .tabItem {
                height: 70px;
                line-height: 70px;
                font-size: 20px;
                color: #000000;
                flex: 1;
                text-align: center;
                cursor: pointer;
                position: relative;

                &::after {
                    content: '';
                    position: absolute;
                    left: 50%;
                    bottom: 0;
                    width: 0%;
                    height: 2px;
                    background: #4B4B4B;
                    transition: all 0.3s;
                }
            }

            .active {
                &::after {
                    content: '';
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 2px;
                    background: #4B4B4B;
                }
            }
        }

        .tabBox2 {
            margin-top: 30px;
            display: flex;
            flex-wrap: nowrap;
            overflow: auto;
            align-items: center;
            gap: 20px;

            .tabItem2 {
                width: 277px;
                height: 155px;
                cursor: pointer;

                .textCenter {
                    display: block;
                    width: 277px;
                    height: 155px;
                    line-height: 155px;
                    text-align: center;
                    color: #fff;
                    font-size: 22px;
                    font-weight: 300;
                    background: linear - gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.8));
                }

            }

            .activeItem2 {
                .textCenter {
                    font-weight: bold;
                    background: transparent;
                }
            }
        }

        .content {
            margin-top: 50px;
            padding-bottom: 50px;

            .title {
                font-size: 24px;
                color: #000000;
                line-height: 30px;
                padding-bottom: 22px;
                padding-left: 30px;
                font-weight: bold;
            }

            .listBox {
                margin-top: 30px;
                display: flex;
                flex-wrap: wrap;
                gap: 30px;

                .listItem {
                    width: calc((100% - 30px) / 2);
                    margin-bottom: 0px;
                    cursor: pointer;

                    img {
                        width: 100%;
                        height: auto;
                        aspect-ratio: 19 / 15;
                        display: block;
                        background-color: #F8F7F7;
                    }

                    .name {
                        text-align: center;
                        margin-top: 15px;
                        text-align: center;
                        font-size: 18px;
                        color: #000000;
                        line-height: 24px;
                    }
                }
            }
        }
    }

}
</style>